import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { DepartmentService } from 'src/app/app-core/services/department.service';
import { PersonService } from 'src/app/app-core/services/person.service';
import { ProccessHistoryService } from 'src/app/app-core/services/proccessHistorory.service';
import { UserService, UsersGroupEnum } from 'src/app/app-core/services/user.service';
import { RequestService } from 'src/app/app-core/services/request.service';
import { ProccessCommentService } from 'src/app/app-core/services/proccessComment.service';
import { CryptoService } from 'src/app/app-core/services/crypto.service';
import { MenuItem, MessageService } from 'primeng/api';

import swal from 'sweetalert2';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { IProccess, ISubmitExtendProcessSchema, ISendRequesterConsiderationsSchema, IRequestToCancelProcessSchema, ICancellationEvaluationSchema, IProcessCorrections, IAddComplementaryFilesSchema, IMarkProcess } from 'src/app/interfaces/proccess.interface';
import { IDepartment } from 'src/app/interfaces/department';
import { IPerson } from 'src/app/interfaces/person';
import { IProcessComment } from 'src/app/interfaces/proccessComment';
import { IProccessHistory } from 'src/app/interfaces/proccessHistory';
import { IListScopeCommentsResponse } from 'src/app/interfaces/listScope/listScopeCommentResponse';
import { IListScopeHistoryProcessResponse } from 'src/app/interfaces/listScope/listScopeHistoryProccessResponse';
import { IListScopeDepartmentResponse } from 'src/app/interfaces/listScope/listScopeDepartmentResponse';
import { IGetEntityProccessResponse } from 'src/app/interfaces/getEntity/getEtityProccessResponse';
import { UploadService } from 'src/app/app-core/services/upload.service';
import { ProcessCorrectionService } from 'src/app/app-core/services/process-correction.service';
import Swal from 'sweetalert2';
import { IChangeRequestDescriptionSchema } from 'src/app/interfaces/request';
import { ProcessStatusEnum } from 'src/app/Enums/ProcessStatusEnum';
import { OrganizationService } from 'src/app/app-core/services/organization.service';
import { Observable } from 'rxjs';
import { typeProcessEnum } from 'src/app/Enums/typeProcessEnum';
import { OrganizationEnum } from 'src/app/Enums/organizationEnum';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { GlobalStateService } from 'src/app/app-core/services/global-state.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { SignedFileDataResponse } from 'src/app/interfaces/signature-gov.interfaces';
import { switchMap } from 'rxjs/operators';
import { SplitButton } from 'primeng/splitbutton';
import {FilingNoteService} from 'src/app/app-core/services/filing-note.service';
import { FilingNoteEnum } from 'src/app/Enums/filingNote.enum';

interface AutoCompleteCompleteEvent {
    originalEvent: Event;
    query: string;
}

@Component({
    selector: 'app-view-process',
    templateUrl: './view-process.component.html',
    styleUrls: ['./view-process.component.scss'],
    providers: [
        ProcessService,
        DepartmentService,
        PersonService,
        ProccessHistoryService,
        UserService,
        RequestService,
        ProccessCommentService,
        UploadService,
        ProcessCorrectionService,
        MessageService,
        OrganizationService,
        FilingNoteService, 
    ],
})
export class ViewProcessComponent extends GerinusBD implements OnInit, AfterViewInit {
    public hasComplements: boolean = false;
    public process: IProccess;
    public swal = swal;
    public modalHistoricoJuntadaVisivel: boolean = false;

    get historicoJuntadaOrdenado(): any[] {
        if (!this.process?.apensadosHistorico) return [];

        const eventos: any[] = [];

        for (const item of this.process.apensadosHistorico) {
            eventos.push({
                ...item,
                _tipoEvento: 'apensacao',
                _data: item.PA_DataApensacao,
            });

            if (item.PA_DataDesapensacao) {
                eventos.push({
                    ...item,
                    _tipoEvento: 'desapensacao',
                    _data: item.PA_DataDesapensacao,
                });
            }
        }

        return eventos.sort((a, b) => new Date(b._data).getTime() - new Date(a._data).getTime());
    }
    public modalName: string = 'tramitar';
    public isCreateParecerModalVisible: boolean = false;
    public parecerDraftEditing: any = null;
    private readonly PARECER_ALLOWED_STATUSES: ProcessStatusEnum[] = [
        ProcessStatusEnum.IN_PROGRESS,
        ProcessStatusEnum.AWAITING_REFUND,
        ProcessStatusEnum.AWAITING_PAYMENT,
    ];
    public forDocuments = [
        {
            name: 'PROCURAÇÃO',
            type: 'procuracao',
        },
        {
            name: 'REQUERIMENTO',
            type: 'requerimento',
        },
        {
            name: 'COMPLEMENTARES',
            type: 'complementar',
        },
    ];
    public departments: IDepartment[];
    public persons: IPerson[];
    public comments: IProcessComment[] = [];
    public histories: IProccessHistory[] = [];
    public commentText: string = '';
    public USR_foto: string;
    public allowedFileMimeTypes: string[] = [
        'application/pdf',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/vnd.rar',
        'application/zip',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/webp',
        'image/tiff',
        'image/svg+xml',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    public mimeTypePdf = ['application/pdf'];
    public mimeTypePdfZip = ['application/pdf', 'application/zip', 'application/x-zip-compressed', 'application/x-rar-compressed', 'application/vnd.rar'];
    public showDropzonePreview: boolean = true;

    public encryptedId: string;
    public tipoTramitacao: string;
    public responsibles: any = [];
    public selectedAddResponsible: any;
    public selectedToggleResponsible: any;
    public sidebarVisible: boolean = false;
    public reasonReturn: string;
    public daysAmountExtendsProcess: number;
    public editDescriptionAllowed: string;
    public isEditingDescription = false;
    public requesterConsiderations = '';
    public corrections: IProcessCorrections[];

    public organizations$: Observable<any>;
    public departamentName: string;
    public organizationId: number | null = null;
    public organizationName: string;
    public departamentsByOrg$: Observable<any>;

    public alreadyFilteredList = {}
    public modalResponsible: string = 'Rejeitar'
    isCancelProcessDialogOpen: boolean = false;
    isArchiveNoteModalOpen: boolean = false;
    isUnarchiveProcessDialogOpen: boolean = false;
    responsibleRequest: any;
    public isLoading: boolean = false;
    public processId: number;
    public damId: string = '';
    public damData: any[] = [];
    public searchPerformed: boolean = false;
    public showDamTable: boolean = false;
    public negociacaoId: string = '';
    public negociacaoData: any[] = [];
    public alvaraData: any[] = [];
    public showNegociacaoTable: boolean = false;
    public showAlvaraTable: boolean = false;
    isSignatureModalOpen: boolean = false;
    isSignatureAlvaraModalOpen: boolean = false;
    public dataPdfNegociacao = null;
    public dataPdfAlvara = null;
    public codigoNegociacaoPdf: number;
    public codigoAlvaraPdf: number;
    public canSearchFisco = false;
    public numeroAlvara: number;
    public exercicioAlvara: number;
    public tipoAlvara: string | null = null;
    public tipoAlvaraLabels: { [key: string]: string } = {
        funcionamento: 'de Funcionamento',
        sanitario: 'Sanitário'
      };

    formattedDams: any[];
    formattedNegociacoes: any[];
    formattedAlvaras: any[]
    public splitActions: MenuItem[] = [];
    isUnarchiveRequestModalOpen: boolean = false;
    isSearchDamModalOpen: boolean = false;
    isSearchNegociacaoModalOpen: boolean = false;
    isSearchAlvaraModalOpen: boolean = false;
    isRequestUnarchive:boolean = false;

    public validStatus: number[] = [
        ProcessStatusEnum.ARCHIVED,
        ProcessStatusEnum.CONCLUDED,
        ProcessStatusEnum.OUTDATED,
        FilingNoteEnum.SOLICITADO_DESARQUIVAMENTO
    ];
    public processAttachmentColumns = ["PA_CodigoAnexo", "PA_Nome", "PA_Anexo", "PA_Status", "created_at", 'PA_MotivoAnulacao','PA_DataAnulacao']
    public processDispatchAttachmentColumns = ["PPD_CodigoParecerDespacho", "PPD_NomeAnexo", "PPD_Anexo", "PPD_Status", "created_at", 'PPD_MotivoAnulacao','PPD_DataAnulacao']
    public processCertificateAttachmentColumns = ["PC_CodigoCertidao", "PC_Nome", "PC_Anexo", "PC_Status", "created_at", 'PC_MotivoAnulacao','PC_DataAnulacao']
    public skeletronLoaded = {
        complementaryFiles: {
            show: false,
            items: 1
        },
        dispatch: {
            show: false,
            items: 1
        },
        correction: {
            show: false,
            items: 1
        },
        certificate: {
            show: false,
            items: 1
        }
    }
    public complementaryFilesFromCorrection = [];
    internalProcess: any;
    lastTramitacao: any;
    isJoining: boolean = false;
    isAddingResponsible: boolean = false;

    public newCorrectionFiles: any[] = [];

    public certificadoData: any[] = [];
    public showCertificadoTable: boolean = false;
    public numeroCertificado: number;
    public exercicioCertificado: number;
    public formattedCertificados: any[];
    public isSearchCertificadoModalOpen: boolean = false;
    public isSignatureCertificadoModalOpen: boolean = false;
    public dataPdfCertificado = null;
    public codigoCertificadoPdf: number;

    constructor(
        public processService: ProcessService,
        public route: ActivatedRoute,
        public router: Router,
        public global: GlobalService,
        public departmentService: DepartmentService,
        public personService: PersonService,
        public processHistoryService: ProccessHistoryService,
        public userService: UserService,
        public requestService: RequestService,
        private commentService: ProccessCommentService,
        private cryptoService: CryptoService,
        private uploadService: UploadService,
        private messageService: MessageService,
        public organizationService: OrganizationService,
        private fiscoService: FiscoService,
        private globalStateService: GlobalStateService,
        private cd: ChangeDetectorRef,
        private filingNoteService: FilingNoteService,
    ) {
        super(global, processService);
        this.showEmptyData = false;
        this.showHeader = false;
        this.showPaginate = false;

        this.afterCreate();
        this.add();
    }

    ngOnInit(): void {

        if (!this.entity) {
            this.entity = {};
          }
        
          if (!this.entity.unarchiveProcess) {
            this.entity.unarchiveProcess = { reasonUnarchive: '' };
          }
        this.route.paramMap.subscribe((params) => {

            try {
                this.encryptedId = params.get('id');
                const processoId = Number(this.cryptoService.decrypt(this.encryptedId));
                this.processId = processoId;
                this.initializeData(processoId);

                if (!processoId) {
                    this.handleRedirect();
                }
            } catch (error) {
                this.handleRedirect();
            }
        });

    }

    public buildSplitActions() {
        this.splitActions = [];

        if (this.canUnarchive) {
            this.splitActions.push({
                label: 'Desarquivar',
                icon: 'ph ph-cardholder text-lg text-default',
                styleClass: 'text-toggle', 
                command: () => this.global.showModalInfo('desarquivar'),
            });
        }

        if (this.canRequestUnarchiving) {
            this.splitActions.push({
                label: 'Solicitar Desarquivamento',
                icon: 'ph ph-cardholder text-lg text-default',
                styleClass: 'text-toggle', 
                command: () => this.isUnarchiveRequestModalOpen = true,
            });
        }

        if (this.canToggleResponsible) {
            this.splitActions.push({
                label: 'Alternar Responsável',
                icon: 'pi pi-user-edit text-toggle',
                styleClass: 'text-toggle', 
                command: () => this.global.showModalInfo('toggle-responsavel')
            });
        }

        if (this.canUpdateToEvaluation) {
            this.splitActions.push({
                label: 'Atualizar para Em Análise',
                icon: 'pi pi-refresh text-warning',
                styleClass: 'text-warning', 
                command: () => this.handleUpdateStatusToEvaluation()
            });
        }

        if (this.canReturnToRequester) {
            this.splitActions.push({
                label: this.process.PCOR_Status === 1 || this.process.Status === 8 ? 'Devolver Novamente' : 'Devolver ao solicitante',
                icon: 'pi pi-arrow-left text-warning',
                styleClass: 'text-warning',
                command: () => this.sidebarVisible = true
            });
        }

        if (this.returnToSenderRole) {
            this.splitActions.push({
                label: 'Devolver ao Transmitente',
                icon: 'pi pi-arrow-left text-yellow',
                styleClass: 'text-yellow',
                command: () => this.global.showModalInfo(this.modalName + '-return-to-sender')
            });
        }

        if (this.canAllProgressActions) {
            this.splitActions.push({
                label: 'Tramitar',
                icon: 'pi pi-arrow-up-right text-transmit',
                styleClass: 'text-transmit',
                command: () => this.global.showModalInfo(this.modalName + '-add-departamento')
            });
        
            this.splitActions.push({
                label: 'Concluir',
                icon: 'pi pi-check text-success',
                styleClass: 'text-success',
                command: () => this.handleCompleteProcess()
            });
        
            this.splitActions.push({
                label: 'Prorrogar Processo',
                icon: 'pi pi-history text-primary',
                styleClass: 'text-primary',
                command: () => this.openExtendProcessModal()
            });
        }
    
        if (this.canArchive) {
            this.splitActions.push({
                label: 'Arquivar',
                icon: 'pi pi-folder text-yellow',
                styleClass: 'text-yellow',
                command: () => this.showModalArchiveNote()
            });
        }

        if (this.shouldShowReopenButton) {
            this.splitActions.push({
                label: 'Reabrir Processo',
                icon: 'pi pi-refresh text-danger',
                styleClass: 'text-danger',
                command: () => this.reopenProcess()
            });
        }

        if (this.isRequestCancellationButtonVisible) {
            this.splitActions.push({
                label: 'Solicitar Anulação',
                icon: 'pi pi-times text-danger',
                styleClass: 'text-danger',
                command: () => this.isCancelProcessDialogOpen = true
            });
        }

        if (this.isCancellationButtonVisible) {
            this.splitActions.push({
                label: 'Anular Processo',
                icon: 'pi pi-times text-danger',
                styleClass: 'text-danger',
                command: () => this.isCancelProcessDialogOpen = true
            });
        }
    }

    desarquivarProcesso() {
        const data: IMarkProcess = {
            PRCH_Historico: `${this.global.user().PE_Nome} desarquivou o processo!`,
            reasonUnarchive: this.entity.unarchive.reasonUnarchive,
        }
        this.processService.markAsUnarchived(this.process.PRC_CodigoProcesso, data ).subscribe(
                 {
                    next: () => {
                        if(this.userService.isDiretorDepartamento() || this.userService.isAdmOrgao() || this.userService.isAdmin()) {
                        this.getProcess(this.process.PRC_CodigoProcesso);
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O processo ' + this.process.PRC_NumeroProcesso + ' foi desarquivado com sucesso.',
                        });
                    } 
                    this.global.closeModalInfo('desarquivar');
                    this.isUnarchiveRequestModalOpen = false;
                    window.location.reload();
                    },
                 }
        )
    }

   

    openActions(splitBtn: SplitButton, event: Event) {
        (splitBtn as any).overlayVisible = true;
        (splitBtn as any).onDropdownButtonClick(event);
      }

    ngAfterViewInit(): void {
        this.cd.detectChanges();
    }

    private handleRedirect(): void {
        if (this.userService.isTriagem()) {
            this.router.navigate(['/process/all'], { queryParams: { 'not-found': true } });
        }
        else if (this.userService.isDiretorDepartamento() || this.userService.isMembroDepartamento()) {
            this.router.navigate(['/process/sector'], { queryParams: { 'not-found': true } });
        }
        else if (this.userService.isCidadao()) {
            this.router.navigate(['/requests/processes'], { queryParams: { 'not-found': true } });
        }
        else if (this.userService.isAdmOrgao() || this.userService.isSecretario()) {
            this.router.navigate(['/process/organization'], { queryParams: { 'not-found': true } });
        }
    }

    private initializeData(processoId: number) {
        this.getProcess(processoId);
        this.getPerson();
        this.getHistories(processoId);
        this.getComments(processoId);
        this.searchResponsibles();
        this.getResponsibleRequests(processoId)
        this.getCorrections(processoId);
    }

    private get _haveDispatch(): boolean {
        return this.process.despachos && this.process.despachos.length > 0;
    }

    public defaults() {
        return {
            documentos: {
                parecerDespacho: [],
                correctionFiles: [],
                userId: this.global.user().USR_CodigoUsuario,
            },
            tramitacao: {
                PRCH_Historico: '',
                NTR_Descricao: '',
                NTR_Autor: ''
            },
            comentario: {
                COM_Descricao: '',
                COM_CodigoUsuario: this.global.user().USR_CodigoUsuario,
                COM_CodigoProcesso: '',
            },
            despacho: {
                PDES_Descricao: '',
                PDES_CodigoUsuario: this.global.user().USR_CodigoUsuario,
            },
            processAttachments: {
                complementaryFiles: [],
                userId: this.global.user().USR_CodigoUsuario,
            },
            processCertificates: {
                certificates: [],
                userId: this.global.user().USR_CodigoUsuario,
            },
            fixedAttachments: {
                documents: []
            },
            cancelProcess: {
                reasonCancel: '',
                evaluationDescription: ''
            },
            archive: {
                archiveNote: ''
            },
            unarchive: {
                reasonUnarchive: ''
            },
        };
    }

    getPerson() {
        this.personService
            .listAll(
                `
                    "PE_CodigoDepartamento" = ${this.global.user().PE_CodigoDepartamento} and
                    "PE_CodigoPessoa" != ${this.global.user().PE_CodigoPessoa} and 
                    "usuario"."USR_Status" = 1
                `,
                0,
            )
            .subscribe({
                next: (response: any) => {
                    this.persons = response.data;
                },
            });
    }

    getHistories(processoId: number) {
        this.processHistoryService
            .listAll(`"PRCH_CodigoProcesso" = ${processoId} AND ("PRCH_Status" IS NULL OR "PRCH_Status" = 1) order by "PRCH_Data" desc`, 0)
            .subscribe({
                next: (response: IListScopeHistoryProcessResponse) => {
                    this.histories = response.data;
                },
            });
    }

    isClickInsideComponent(event: MouseEvent, componentName: string): boolean {
        const clickedComponent = event.target as HTMLElement;

        return (
            clickedComponent.classList.contains(componentName) || clickedComponent.closest(`.${componentName}`) !== null
        );
    }

    getComments(processId: number) {
        this.commentService
            .listAll(`"COM_CodigoProcesso" = ${processId} order by "COM_DataComentario" desc`, 0)
            .subscribe({
                next: (response: IListScopeCommentsResponse) => {
                    this.comments = response.data.map((comment) => {
                        return {
                            ...comment,
                            formattedDate: formatDistanceToNow(new Date(comment.COM_DataComentario), {
                                addSuffix: true,
                                locale: ptBR,
                            }),
                        };
                    });
                },
            });
    }

    getDepartments() {
        const userOrgId = this.global.user().OR_CodigoOrgao;
        this.departmentService
            .listAll(
                `
                "DEP_CodigoOrgao" = ${userOrgId} and
                "DEP_CodigoDepartamento" != ${this.process.PRT_DepartamentoAtual}
                order by "DEP_Descricao" asc
                `,
                0,
            )
            .subscribe({
                next: (response: IListScopeDepartmentResponse) => {
                    this.departments = response.data.filter(dep => 
                        dep.DEP_TipoProcessoAceito === 1 || dep.DEP_TipoProcessoAceito === 3
                    );
                },
                error: (error) => {
                    console.log('ERRO', error);
                },
            });
    }

    getProcess(id: number, onComplete?: () => void) {
        this.processService.getEntity(id).subscribe({
            next: async (response: IGetEntityProccessResponse) => {
                this.process = response.entity;
                this.process.PRC_DataRecebimento = new Date(this.process.PRC_DataRecebimento);
                this.process.PRC_DataRecebimento.setHours(this.process.PRC_DataRecebimento.getHours() + 3);
                this.updatePermissionFisco();
                this.skeletonHidden();
                this.getDepartments();
                this.getPerson();
                this.buildSplitActions();

                document.querySelector('title').text = 'Processo N° ' + this.process.PRC_NumeroProcesso;
            },
            complete: () => {
                this.formatDamData();
                this.formatNegociacaoData();
                this.formatAlvaraData();
                this.formatCertificadoData();

                if (onComplete) {
                    onComplete();
                }
            },
        });
    }

    formatDamData() {
        const damPromises = this.process.dam.map((dam) => {
            return new Promise((resolve) => {
                this.fiscoService.getDataDam(dam.PDAM_NumeroDam).subscribe({
                    next: (response: any) => {
                        if (response.success) {
                            const dam = {
                                contribuinte: response.data.contribuinte,
                                id: response.data.id,
                                link: response.data.link,
                                receita: response.data.receita,
                                situacao: response.data.situacao,
                                valor: response.data.valor,
                                vencimento: response.data.vencimento,
                            };
                            resolve(dam);
                        } else {
                            resolve(null);
                        }
                    },
                    error: () => {
                        resolve(null);
                    }
                });
            });
        });

        Promise.all(damPromises).then((dams) => {
            this.formattedDams = dams;
            this.showDamTable = true;
        });
    }

    formatNegociacaoData() {
        if (!this.process?.negociacao || this.process.negociacao.length === 0) {
            this.formattedNegociacoes = [];
            this.showNegociacaoTable = false;
            return;
        }

        const negociacaoPromises = this.process.negociacao.map((negociacao) => {
            return new Promise((resolve) => {
                this.fiscoService.getDataNegociacao(negociacao.PNEG_NumeroNegociacao).subscribe({
                    next: (response: any) => {
                        if (response.success) {
                            const negociacaoData = {
                                codigo: negociacao?.PNEG_CodigoProcessoNegociacao,
                                contribuinte: response.data.contribuinte,
                                id: response.data.id,
                                link: response.data.link,
                                anexoCloudflare: negociacao?.PNEG_Anexo,
                                receita: response.data.receita,
                                situacao: response.data.situacao,
                                valor: response.data.valor,
                                data: response.data.data,
                                assinado: negociacao?.PNEG_Assinado
                            };
                            resolve(negociacaoData);
                        } else {
                            resolve(null);
                        }
                    },
                    error: () => {
                        resolve(null);
                    }
                });
            });
        });

        Promise.all(negociacaoPromises).then((negociacoes) => {
            this.formattedNegociacoes = negociacoes.filter(n => n !== null);
            this.showNegociacaoTable = true;
        });
    }

    formatAlvaraData() {
        if (!this.process?.alvara || this.process.alvara.length === 0) {
            this.formattedAlvaras = [];
            this.showAlvaraTable = false;
            return;
        }

        const alvaraPromises = this.process.alvara.map((alvara) => {
            return new Promise((resolve) => {
                this.fiscoService.getDataAlvara(alvara.PALV_Tipo, alvara.PALV_Numero, alvara.PALV_Exercicio).subscribe({
                    next: (response: any) => {
                        if (response.success) {
                            const alvaraData = {
                                codigo: alvara?.PALV_CodigoProcessoAlvara,
                                contribuinte: response.data.contribuinte,
                                numero: response.data.numero,
                                link: response.data.link,
                                situacao: response.data.situacao,
                                vencimento: response.data.vencimento,
                                status_dam: response.data.status_dam,
                                tipo: alvara?.PALV_Tipo === 'funcionamento' ? 'Funcionamento'
                                    : alvara?.PALV_Tipo === 'sanitario' ? 'Sanitário'
                                        : alvara?.PALV_Tipo,
                                exercicio: alvara?.PALV_Exercicio,
                                anexoCloudflare: alvara?.PALV_Anexo,
                                assinado: alvara?.PALV_Assinado
                            };
                            resolve(alvaraData);
                        } else {
                            resolve(null);
                        }
                    },
                    error: () => {
                        resolve(null);
                    }
                });
            });
        });

        Promise.all(alvaraPromises).then((alvaras) => {
            this.formattedAlvaras = alvaras.filter(a => a !== null);
            this.showAlvaraTable = true;
        });
    }

    openExtendProcessModal(): void {
        this.global.showModalInfo('prorrogar-processo');
    }

    handleExtendsProcess(): void {
        if (this.daysAmountExtendsProcess > this.process.AS_PrazoProcesso) {
            this.messageService.add({
                severity: 'warn',
                icon: 'ph ph-warning',
                summary: 'Atenção!',
                detail: `O número máximo de dias é ${this.process.AS_PrazoProcesso}.`,
            });
            return;
        }

        const extendsProcessData: ISubmitExtendProcessSchema = {
            processId: this.process.PRC_CodigoProcesso,
            daysAmount: this.daysAmountExtendsProcess
        }

        this.processService.submitExtendsProcess(extendsProcessData).subscribe({
            next: (response: any) => {
                this.getProcess(this.process.PRC_CodigoProcesso);
                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'O processo foi prorrogado com sucesso.',
                });
                this.global.closeModalInfo('prorrogar-processo');
            }
        })
    }

    handleCompleteProcess(): void {
        if (!this._haveDispatch && !this.userService.isCoordTributaria()) {
            this.showMissingDispatchAlert('conclusao');
        } else {
            const completeProcessData = {
                PRCH_Historico: `${this.global.user().PE_Nome} concluiu o processo!`,
            };

            this.confirmProcessAction('conclusao', () => {
                this.processService
                    .markProcessAsCompleted(this.process.PRC_CodigoProcesso, completeProcessData)
                    .subscribe({
                        next: async () => {
                            await this.getProcess(this.process.PRC_CodigoProcesso);

                            this.messageService.add({
                                severity: 'success',
                                icon: 'ph ph-check-circle',
                                closable: true,
                                summary: 'Sucesso!',
                                detail: 'O processo foi marcado como concluído.',
                            });
                        },
                    });
            });
        }
    }

    handleArchiveProcess(): void {
        const archiveProcessData = {
            PRCH_Historico: `${this.global.user().PE_Nome} arquivou o processo!`,
            archiveNote: this.entity.archive.archiveNote
        };

        this.processService
            .markProcessAsArchived(this.process.PRC_CodigoProcesso, archiveProcessData)
            .subscribe({
                next: async () => {
                    await this.getProcess(this.process.PRC_CodigoProcesso);
                    this.isArchiveNoteModalOpen = false
                    this.messageService.add({
                        severity: 'success',
                        icon: 'ph ph-check-circle',
                        closable: true,
                        summary: 'Sucesso!',
                        detail: 'O processo foi marcado como arquivado.',
                    });
                },
            });
    }

    handleSaveDispatch() {
        this.processService.addDispatch(this.process.PRC_CodigoProcesso, this.entity.despacho).subscribe({
            next: () => {
                this.entity.despacho.PDES_Descricao = '';

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'Novo despacho adicionado.',
                });

                this.getProcess(this.process.PRC_CodigoProcesso);
            },
        });
    }

    handleAddResponsible() {
        if (this.isAddingResponsible) {
            return;
        }

        if (!this.selectedAddResponsible) {
            this.messageService.add({
                severity: 'warn',
                icon: 'ph ph-warning',
                closable: true,
                summary: 'Atenção!',
                detail: 'Selecione um responsável antes de salvar.',
            });
            return;
        }

        this.isAddingResponsible = true;

        const addResponsibleData = {
            PRC_CodigoResponsavel: this.selectedAddResponsible.PE_CodigoPessoa,
            PRCH_Historico: `${this.global.user().PE_Nome} adicionou ${this.selectedAddResponsible.PE_Nome} como responsável do processo`,
        };

        this.processService.addResponsible(this.process.PRC_CodigoProcesso, addResponsibleData).subscribe({
            next: async () => {
                this.global.closeModalInfo('add-responsavel');

                this.getProcess(this.process.PRC_CodigoProcesso, () => {
                    this.isAddingResponsible = false;
                    this.selectedAddResponsible = null;
                });

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'Um novo responsável por este processo foi designado.',
                });
            },
            error: (err) => {
                this.isAddingResponsible = false;
                
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: 'Não foi possível adicionar o responsável.',
                });
            }
        });
    }

    handleToggleResponsible() {
        const toggleResponsibleData = {
            PRC_CodigoResponsavel: this.selectedToggleResponsible.PE_CodigoPessoa,
            PRCH_Historico: `${this.global.user().PE_Nome} alternou o responsável para ${this.selectedToggleResponsible.PE_Nome} no processo`,
        };

        this.processService.toggleResponsible(this.process.PRC_CodigoProcesso, toggleResponsibleData).subscribe({
            next: async () => {
                this.global.closeModalInfo('toggle-responsavel');
                await this.getProcess(this.process.PRC_CodigoProcesso);

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'O responsável deste processo foi alternado com sucesso.',
                });
            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-exclamation-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: 'Ocorreu um erro ao alternar o responsável. Tente novamente.',
                });
            }
        });
    }

    private showMissingDispatchAlert(action: 'arquivacao' | 'conclusao'): void {
        this.global.swal.fire({
            title: `Erro ao ${action === 'arquivacao' ? 'arquivar' : 'concluir'} Processo`,
            text: 'Você precisa de um despacho para concluir a ação',
            icon: 'error',
        });
    }

    private confirmProcessAction(actionField: 'arquivacao' | 'conclusao', action: () => void) {
        this.global.swal
            .fire({
                title: `Você deseja ${actionField === 'arquivacao' ? 'arquivar' : 'concluir'} o Processo?`,
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim',
            })
            .then((result) => {
                if (result.isConfirmed) {
                    action();
                }
            });
    }

    joinOnProccess() {
        if (this.isJoining) {
            return;
        }

        this.isJoining = true;

        const joinOnProccessData = {
            PRCH_Historico: `O processo está em análise por ${this.global.user().PE_Nome}`,
            PRC_CodigoResponsavel: this.global.user().PE_CodigoPessoa,
        };

        this.processService.join(this.process.PRC_CodigoProcesso, joinOnProccessData).subscribe({
            next: async () => {
                this.getProcess(this.process.PRC_CodigoProcesso, () => {
                    this.isJoining = false;
                });

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'Você agora é responsável pelo processo.',
                });
            },
            error: (err) => {
                this.isJoining = false;
                
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: 'Não foi possível ingressar no processo.',
                });
            }
        });
    }

    transmitProcess(type) {
        if (this.InvalidNote) {
            this.messageService.add({
                severity: 'error',
                icon: 'ph ph-x-circle',
                closable: true,
                summary: 'Erro!',
                detail: 'A nota de tramitação é obrigatória.',
            });
            return;
        }
        if (type === 'interna') {
            this.entity.tramitacao.PRCH_Historico = `${this.global.user().PE_Nome
                } tramitou para ${this.mappingPersons()} - Aceite pendente`;
        } else if (type === 'externa') {
            this.entity.tramitacao.PRCH_Historico = `${this.global.user().PE_Nome
                } tramitou para ${this.mappingDepartamento()}`;
        } else if (type === 'externa-orgao') {
            this.entity.tramitacao.PRCH_Historico = `${this.global.user().PE_Nome} tramitou para ${this.departamentName} do orgão ${this.organizationName}`;
        }

        this.entity.tramitacao.NTR_Autor = this.global.user().PE_CodigoPessoa;
        this.entity.tramitacao.PRC_DepartamentoTramitador = this.global.user().PE_CodigoDepartamento;
        this.entity.tramitacao.USR_CodigoUsuario = this.global.user().USR_CodigoUsuario;
        this.entity.tramitacao.PE_CodigoDepartamento = this.global.user().PE_CodigoDepartamento;
        this.entity.tramitacao.PE_CodigoPessoa = this.global.user().PE_CodigoPessoa;
        this.global.startLoading('Tramitando...', true);
        this.processService.transmit(this.process.PRC_CodigoProcesso, this.entity.tramitacao).subscribe({
            next: async () => {
                this.global.closeModalInfo(this.modalName + '-add-departamento');

                if (type == 'externa') {
                    this.global.router.navigate(['/process/transferred']);
                }

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'Um novo responsável por este processo foi designado.',
                });
                await this.getProcess(this.process.PRC_CodigoProcesso);
                await this.getResponsibleRequests(this.process.PRC_CodigoProcesso); 
                this.global.stopLoading();
            },
        });
    }

    get prazoRestanteNotificacao(): number | null {
        const prazoDias = this.process?.PRC_PrazoNotificacaoProcesso;
        const dataInicioTramitacao = this.process?.PRT_DataInicio;
    
        if (!prazoDias || !dataInicioTramitacao) return null;
    
        const inicio = new Date(dataInicioTramitacao);
        const hoje = new Date();
    
        const diffEmMilissegundos = hoje.getTime() - inicio.getTime();
        const diasDecorridos = Math.floor(diffEmMilissegundos / (1000 * 60 * 60 * 24));
    
        const diasRestantes = prazoDias - diasDecorridos;
    
        return diasRestantes >= 0 ? diasRestantes : 0;
    }

    get latestTramitacaoNote() {
        if (!this.process?.nota_tramitacao || this.process.nota_tramitacao.length === 0) {
            return null;
        }

        return this.process.nota_tramitacao.sort(
            (a, b) => new Date(b.NTR_Data).getTime() - new Date(a.NTR_Data).getTime(),
        )[0];
    }

    mappingDepartamento() {
        return this.departments.filter((departament) => {
            return departament.DEP_CodigoDepartamento == this.entity.tramitacao.PRC_CodigoDepartamentoAtual;
        })[0].DEP_Descricao;
    }

    public mappingPersons() {
        return this.persons.filter((person) => {
            return person.PE_CodigoPessoa == this.entity.tramitacao.PRC_CodigoResponsavel;
        })[0].PE_Nome;
    }

    public handleNavigationBackButton() {
        if (this.userService.isCidadao()) {
            this.global.router.navigate(['/requests/all']);
        } else {
            window.history.back();
        }
    }

    public get isResponsible(): boolean {
        return this.process?.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa;
    }

    public markLatestTramitacaoNoteAsRead(): void {
        if (!this.process || !this.latestTramitacaoNote) {
            return;
        }

        const noteId = this.latestTramitacaoNote.NTR_CodigoNota;
        if (!noteId) {
            this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Não foi possível marcar a nota como lida.',
            });
            return;
        }

        this.processService.markTramitacaoNoteAsRead(this.process.PRC_CodigoProcesso, noteId).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Nota marcada como lida.',
                });
                this.getProcess(this.process.PRC_CodigoProcesso);
            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: `Não foi possível marcar a nota como lida.`,
                });
            },
        });
    }

    addComment() {
        if (this.commentText.trim() !== '') {
            this.entity.comentario.COM_Descricao = this.commentText;
            this.entity.comentario.COM_CodigoUsuario = this.global.user().USR_CodigoUsuario;
            this.entity.comentario.COM_CodigoProcesso = this.process.PRC_CodigoProcesso;
            this.entity.comentario.COM_DataComentario = new Date();
            this.entity.comentario.USR_foto = this.global.user().USR_foto;
            this.saveComment();
        }
    }

    private saveComment() {
        this.entity.comentario.COM_Descricao = this.commentText;
        this.commentService.save(this.entity.comentario).subscribe({
            next: (response: any) => {
                this.commentText = '';
                this.comments.unshift({
                    ...response.entity,
                    USR_foto: this.global.user().USR_foto,
                    formattedDate: formatDistanceToNow(new Date(response.entity.COM_DataComentario), {
                        addSuffix: true,
                        locale: ptBR,
                    }),
                });

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'Novo comentário adicionado ao processo.',
                });
            },
        });
    }

    initCommentEdition(comentario: any) {
        comentario.editText = comentario.COM_Descricao;
    }

    handleSaveCommentEdition(comentario: any) {
        comentario.COM_Descricao = comentario.editText;

        this.commentService.save(comentario).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'O comentário foi alterado.',
                });
                this.global.closeModalInfo(this.modalName + comentario.COM_CodigoComentario);
            },
        });
    }

    getStatusClass(status: string): string {
        switch (status) {
            case '1':
                return 'badge-primary';
            case '2':
                return 'badge-success';
            default:
                return 'badge-default';
        }
    }

    getUploadedFile(event: any) {
        if (event.file.typeDocument === 'correctionFiles') {
            this.entity.documentos.correctionFiles.push(event.file);
            return;
        }
        this.showDropzonePreview = true;
        this.entity.documentos[event.file.typeDocument].push(event.file);
        this.handleSaveDispatchReport(event.file, 1);
    }

    async onDeleteFileUploaded(event?: any) {
        if (!event.typeDocument) {
          event.typeDocument = 'correctionFiles';
        }
        if (event.typeDocument === 'correctionFiles') {
            this.entity.documentos.correctionFiles = 
                this.entity.documentos.correctionFiles.splice(event.index, 1);
            return;
        }
        this.handleSaveDispatchReport(event, 0);
    }

    get parecerDrafts(): any[] {
        if (!this.process?.parecer_despacho) return [];
        if (this.userService.isCidadao()) return [];
        return (this.process.parecer_despacho as any[]).filter(
            (p) => p.PPD_StatusRascunho === 'RASCUNHO' && !p.PPD_Assinado && p.PPD_Status !== 0,
        );
    }

    get parecerAwaitingSecretary(): any[] {
        if (!this.process?.parecer_despacho) return [];
        if (this.userService.isCidadao()) return [];
        return (this.process.parecer_despacho as any[]).filter(
            (p) => p.PPD_StatusRascunho === 'AGUARDANDO_SECRETARIO' && p.PPD_Status !== 0,
        );
    }

    private _parecerVisibleFilesCache: { source: any[] | null; result: any[] } = { source: null, result: [] };
    get parecerVisibleFiles(): any[] {
        const source = (this.process?.parecer_despacho as any[] | undefined) ?? null;
        if (this._parecerVisibleFilesCache.source === source) {
            return this._parecerVisibleFilesCache.result;
        }
        const result = source
            ? source.filter((p) => {
                  if (p.PPD_Status === 0) return true;
                  return p.PPD_StatusRascunho === 'ASSINADO' && p.PPD_Assinado;
              })
            : [];
        this._parecerVisibleFilesCache = { source, result };
        return result;
    }

    get hasActiveParecer(): boolean {
        if (!this.process?.parecer_despacho) return false;
        return (this.process.parecer_despacho as any[]).some((p) => p.PPD_Status !== 0);
    }

    discardParecerDraft(draft: any): void {
        if (!draft?.PPD_CodigoParecerDespacho) return;
        Swal.fire({
            title: 'Descartar rascunho?',
            text: 'O rascunho do parecer de despacho será removido permanentemente.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sim, descartar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (!result.isConfirmed) return;
            this.processService
                .discardParecerDraft(this.process.PRC_CodigoProcesso, draft.PPD_CodigoParecerDespacho)
                .subscribe({
                    next: () => {
                        this.getProcess(this.process.PRC_CodigoProcesso);
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'Rascunho descartado com sucesso.',
                        });
                    },
                    error: (err) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erro',
                            detail: err?.error?.message || 'Não foi possível descartar o rascunho.',
                        });
                    },
                });
        });
    }

    canCreateParecer(): boolean {
        if (!this.process) return false;
        const user = this.global.user();
        const isResponsible = this.process.PRC_CodigoResponsavel == user?.PE_CodigoPessoa;
        const validStatus = this.PARECER_ALLOWED_STATUSES.includes(this.process.Status as ProcessStatusEnum);

        return isResponsible && validStatus && !this.hasActiveParecer;
    }

    canEditDraft(draft: any): boolean {
        if (!this.process || !draft) return false;
        if (draft.PPD_Assinado || draft.PPD_StatusRascunho !== 'RASCUNHO') return false;
        const user = this.global.user();
        const isResponsible = this.process.PRC_CodigoResponsavel == user?.PE_CodigoPessoa;
        const validStatus = this.PARECER_ALLOWED_STATUSES.includes(this.process.Status as ProcessStatusEnum);
        return isResponsible && validStatus;
    }

    openCreateParecerModal(): void {
        this.parecerDraftEditing = null;
        this.isCreateParecerModalVisible = true;
    }

    openEditParecerModal(draft: any): void {
        this.parecerDraftEditing = draft;
        this.isCreateParecerModalVisible = true;
    }

    onParecerModalClosed(): void {
        this.isCreateParecerModalVisible = false;
        this.parecerDraftEditing = null;
    }

    onParecerSaved(parecer: any): void {
        this.getProcess(this.process.PRC_CodigoProcesso);
        if (parecer?.__signedJustNow) {
            this.messageService.add({
                severity: 'success',
                icon: 'ph ph-check-circle',
                closable: true,
                summary: 'Sucesso!',
                detail: 'Parecer de despacho assinado com sucesso.',
            });
        }
    }

    handleSaveDispatchReport(file, status: number) {
        const data = {
            parecerDespacho: file,
            userId: this.global.user().USR_CodigoUsuario,
            status,
            justificativa: file.justificativa
        }

        this.skeletronLoaded.dispatch.items = status == 0? this.process.parecer_despacho.length : this.process.parecer_despacho.length + 1;
        this.skeletronLoaded.dispatch.show = true;
        this.processService.addDispatchReport(this.process.PRC_CodigoProcesso, data).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: status == 0? 'Parecer de despacho anulado com sucesso' : 'Um novo parecer de despacho foi adicionado ao processo.',
                });

                this.getProcess(this.process.PRC_CodigoProcesso);
            },
            error: (err) => {
                this.skeletronLoaded.dispatch.show = false;
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro',
                    detail: err?.error?.message || (status == 0
                        ? 'Não foi possível anular o parecer de despacho.'
                        : 'Não foi possível anexar o parecer de despacho.'),
                });
            },
        });
    }

    public getUploadedComplementaryFiles(event: any) {
        this.showDropzonePreview = true;
        this.entity.processAttachments[event.file.typeDocument].push(event.file);
        this.handleSaveComplementaryFiles(event.file, 1);
    }

    public onCancelComplementaryFilesUploaded(event?: any, index?: number) {
        this.handleSaveComplementaryFiles(event, 0);
    }

    public handleSaveComplementaryFiles(file, status: number) {
        const data: IAddComplementaryFilesSchema = {
            complementaryFile: file,
            userId: this.global.user().USR_CodigoUsuario,
            status: status,
            justificativa: file.justificativa
        }

        this.skeletronLoaded.complementaryFiles.items = status == 0? this.process.processo_anexo.length : this.process.processo_anexo.length + 1;
        this.skeletronLoaded.complementaryFiles.show = true;
        this.processService
            .addComplementaryFiles(this.process.PRC_CodigoProcesso, data)
            .subscribe({
                next: () => {
                    this.entity.despacho.PDES_Descricao = '';
                    this.getProcess(this.process.PRC_CodigoProcesso);
                    this.messageService.add({
                        severity: 'success',
                        icon: 'ph ph-check-circle',
                        closable: true,
                        summary: 'Sucesso!',
                        detail: status == 0?  'Documento complementar anulado com sucesso': 'Novo documento complementar adicionado ao processo',
                    });
                },
        });
    }

    public getUploadedCertificate(event: any) {        
        this.handleSaveCertificate(event?.file, 1);
    }

    public onDeleteCertificateUploaded(event?: any, index?: number) {
        this.handleSaveCertificate(event, 0);
    }

    public handleSaveCertificate(file: any, status: number) {
        const data = {
            certificates: file,
            userId: this.global.user().USR_CodigoUsuario,
            status,
            justificativa: file.justificativa
        }

        this.skeletronLoaded.certificate.items = status == 0? this.process.processo_certidao.length : this.process.processo_certidao.length + 1;
        this.skeletronLoaded.certificate.show = true;

        this.processService.addCertificate(this.process.PRC_CodigoProcesso, data).subscribe({
            next: () => {

                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: status == 0? 'Certidão anulada com sucesso' : 'Nova certidão adicionada ao processo',
                });

                this.getProcess(this.process.PRC_CodigoProcesso);
            },
        });
    }

    public getUploadedFixedAttachment(event: any) {
        this.showDropzonePreview = true;
        this.entity.fixedAttachments.documents.push(event.file);
    }

    public onDeleteFixedAttachmentUploaded(event?: any, index?: number) {
        const documentosArray = this.entity.fixedAttachments.documents;

        if (documentosArray && documentosArray.length >= event.index) {
            documentosArray.splice(event.index - 1, 1);
        }

        console.log('DOCUMENTOS', documentosArray);
    }

    getDocumentoTypes(documentos: any): string[] {
        return Object.keys(documentos);
    }

    handleSaveRequesterCorrection() {
        let message = '';

        if (!this.requesterConsiderations.trim()) {
            message += 'É necessário adicionar considerações para prosseguir.\n';
        }
    
        if (!this.requesterConsiderations.trim()) {
            Swal.fire({
                title: 'Ajustes',
                html: message.replace(/\n/g, '<br>'),
                icon: 'warning',
                confirmButtonColor: '#417bff',
                cancelButtonColor: '#d33',
            });
        } 
        else {
            Swal.fire({
                title: 'Prosseguir com a correção?',
                text: 'Antes de prosseguir, verifique se anexou corretamente os documentos corrigidos conforme as considerações do responsável.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#417bff',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    const correctionData = {
                        documents: this.entity.fixedAttachments.documents,
                        personId: this.global.user().PE_CodigoPessoa,
                        complementaryFiles: this.complementaryFilesFromCorrection
                    };

                    const considerationsData: ISendRequesterConsiderationsSchema = {
                        considerations: this.requesterConsiderations.trim(),
                        correctionId: this.process.PCOR_CodigoCorrecao,
                        PRCH_Historico: `O ${this.global.user().PE_Nome} adicionou considerações ao processo`
                    }
    
                    this.processService
                        .sendRequesterCorrection(this.process.PRC_CodigoProcesso, { correctionData, considerationsData})
                        .subscribe({
                            next: () => {
                                this.messageService.add({
                                    severity: 'success',
                                    icon: 'ph ph-check-circle',
                                    closable: true,
                                    summary: 'Sucesso!',
                                    detail: 'Sua correção será avaliada pelo responsável. Se estiver tudo certo, o responsável dará continuidade ao processo.',
                                    life: 8000
                                });
    
                                this.showDropzonePreview = false;
                                this.getProcess(this.process.PRC_CodigoProcesso);
                                this.getCorrections(this.process.PRC_CodigoProcesso);
                            },
                        });
                } else {
                    Swal.close();
                }
            });
        }
    }

    get hasFixedAttachmentsUploaded(): boolean {
        return (
            this.entity.fixedAttachments.procuracao.length > 0 ||
            this.entity.fixedAttachments.requerimento.length > 0 ||
            this.entity.fixedAttachments.complementar.length > 0
        );
    }

    public downloadFile(attachmentName: string, organization: string) {
        this.uploadService.download(attachmentName, organization).subscribe({
            next: (response: any) => {
                if (response.url) {
                    window.open(response.url, '_blank');
                }
            },
            error: (error: any) => {
                console.error('Erro no download:', error);
            },
        });
    }

    public navigateToDirectMessages() {
        this.global.router.navigate([`process/view/${this.encryptedId}/mail/received`]);
    }

    async searchResponsibles() {
        let condition = `"USR_UsuarioInterno" = true AND "PE_CodigoPessoa" != ${this.global.user().PE_CodigoPessoa}`

        if (this.userService.isDiretorDepartamento()) {
            condition = '"PE_CodigoDepartamento" = ' + this.global.user().PE_CodigoDepartamento
        }

        this.userService.listAll(condition, 0).subscribe({
            next: (response: any) => {
                this.responsibles = response.data;
            }
        })
    }

    public toggleFields() {
        if (this.tipoTramitacao === 'interna') {
            this.entity.tramitacao.PRC_CodigoDepartamentoAtual = null;
        } else if (this.tipoTramitacao === 'externa') {
            this.getDepartments();
            this.entity.tramitacao.PRC_CodigoResponsavel = null;
        } else if (this.tipoTramitacao === 'externa-orgao') {
            this.getOrganization();
            this.entity.tramitacao.PRC_CodigoResponsavel = null;
        }
    }

    public getOrganization() {
        this.organizations$ = this.organizationService.listAll(`"OR_TipoProcessoAceito" = ${typeProcessEnum.INTERNO_EXTERNO} OR "OR_TipoProcessoAceito" = ${typeProcessEnum.EXTERNO}`);
    }

    public changeOrganization() {
        this.entity.tramitacao.PIT_CodigoDepartamentoAtual = null;
        this.organizationService.getEntity(this.organizationId).subscribe({
            next: (response: any) => {
                this.organizationName = response.entity.orgao.OR_Descricao;
            }
        })
        this.departamentsByOrg$ = this.departmentService.listAll(`"DEP_CodigoOrgao" = ${this.organizationId} AND ("DEP_TipoProcessoAceito" = ${typeProcessEnum.INTERNO_EXTERNO} OR "DEP_TipoProcessoAceito" = ${typeProcessEnum.EXTERNO})`);
    }

    public changeDepartaments() {
        this.departmentService.getEntity(this.entity.tramitacao.PRC_CodigoDepartamentoAtual).subscribe({
            next: (response: any) => {
                this.departamentName = response.entity.DEP_Descricao
            }
        });
    }

    public async handleReturnToRequester() {
        this.sidebarVisible = false;

        const sendToCorrectionData = {
            description: this.reasonReturn,
            history: `O processo foi movido para correção por ${this.global.user().PE_Nome}`,
            attachments: this.entity.documentos.correctionFiles,
            editDescription: this.editDescriptionAllowed,
            personId: this.global.user().PE_CodigoPessoa
        };

        try {
            await this.processService.sendToCorrection(
                this.process.PRC_CodigoProcesso, 
                sendToCorrectionData
            ).toPromise();
    
            this.entity.documentos.correctionFiles = [];
            this.reasonReturn = '';
            this.messageService.add({
                severity: 'success',
                icon: 'ph ph-check-circle',
                closable: true,
                summary: 'Sucesso!',
                detail: 'O processo foi enviado para correção.',
            });
    
            await this.getProcess(this.process.PRC_CodigoProcesso);
        } catch (error) {
            console.error('Erro ao enviar processo para correção:', error);
            this.messageService.add({
                severity: 'error',
                icon: 'ph ph-x-circle',
                closable: true,
                summary: 'Erro!',
                detail: 'Falha ao enviar o processo para correção.',
            });
        }
    }

    public correctNameType(type: string) {
        if (type == 'procuracao') {
            return 'PROCURAÇÃO';
        } else {
            return type;
        }
    }

    public deleteFile(name: string, table: string) {

        Swal.fire({
            title: 'Tem certeza que deseja apagar este arquivo?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                this.uploadService.deleteFile(name, table, this.process.OR_Sigla).subscribe({
                    next: () => {
                        this.getProcess(this.process.PRC_CodigoProcesso);
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O arquivo foi apagado com sucesso.',
                        });
                    }
                })
            } else {
                Swal.close()
            }
        });
    }

    getTiposDocumentos(): string[] {
        return Array.from(new Set(this.process.documentos.map((item) => item.SOLA_Tipo)));
    }

    getDocumentosByTipo(tipo: string): any[] {
        return this.process.documentos.filter((item) => item.SOLA_Tipo === tipo);
    }

    handleUpdateStatusToEvaluation() {
        Swal.fire({
            title: 'Tem certeza que deseja atualizar o processo para Em Análise?',
            text: 'Verifique se todos os documentos necessários estão corretos antes de realizar esta ação.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.updateStatusToEvaluation(this.process.PRC_CodigoProcesso).subscribe({
                    next: () => {
                        this.getProcess(this.process.PRC_CodigoProcesso);
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O processo foi atualizado para Em Andamento',
                        });
                    }
                })
            } else {
                Swal.close()
            }
        });
    }

    filterDocumentByType(type: string) {
        const list = this.process.documentos.filter((document) => document.SOLA_Tipo === type);
        return list;
    }

    isNewDocumentType(type: string, index: number): boolean {
        if (!this.alreadyFilteredList[type]) {
            this.alreadyFilteredList[type] = index;
            return true;
        }
        return this.alreadyFilteredList[type] === index;
    }

    enableEditing() {
        this.isEditingDescription = true;
    }

    saveDescription() {
        const editDescriptionRequest: IChangeRequestDescriptionSchema = {
            requestId: Number(this.process.PRC_CodigoSolicitacao),
            description: this.process.SOL_Descricao
        }

        this.requestService.updateProcessDescription(editDescriptionRequest).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Descrição atualizada com sucesso'
                });

                this.isEditingDescription = false;
            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Falha ao atualizar a descrição'
                });
                console.error(err);
            }
        });
    }

    public get hasResponsible() {
        return this.process?.responsavel?.PE_CodigoPessoa == this.global.user()?.PE_CodigoPessoa
    }

    public get listResponsiblesRule() {
        if (this.responsibles) {
            return this.responsibles.filter((item) => item.PE_CodigoPessoa != this.global.user().PE_CodigoPessoa)
        }
    }

    public get InvalidNote(): boolean {
        return !this.entity.tramitacao.NTR_Descricao || !this.entity.tramitacao.NTR_Descricao.trim();
    }

    public get canFixDocuments(): boolean {
        return (this.global.user().PE_CodigoPessoa === this.process.SOL_CodigoSolicitante ||
            (this.userService.isTriagem() && this.process.createdByGroup === 'TRIAGEM')) &&
            ProcessStatusEnum.IN_CORRECTION === this.process.Status &&
            this.process.PCOR_Status === 0
    }

    public get canAddConsiderations(): boolean {
        return (this.global.user().PE_CodigoPessoa === this.process.SOL_CodigoSolicitante ||
            (this.userService.isTriagem() && this.process.createdByGroup === 'TRIAGEM')) &&
            (this.process.Status === ProcessStatusEnum.IN_CORRECTION || this.process.Status === ProcessStatusEnum.ANSWERED) &&
            !this.process.PCOR_RetornoCidadao
    }

    public get canViewCorrectionDetails(): boolean {
        return (this.global.user().PE_CodigoPessoa === this.process.SOL_CodigoSolicitante ||
            this.global.user().USR_CodigoOrgao === this.process.SOL_CodigoOrgao) &&
            (this.process.Status === ProcessStatusEnum.IN_CORRECTION || this.process.Status === ProcessStatusEnum.ANSWERED)
    }

    public get canUploadProcessAttachments(): boolean {
        const allowedStatus = [ProcessStatusEnum.IN_PROGRESS, ProcessStatusEnum.IN_CORRECTION, ProcessStatusEnum.AWAITING_REFUND, ProcessStatusEnum.AWAITING_PAYMENT];

        return ((this.process.PRC_CodigoResponsavel == this.global.user().PE_CodigoPessoa) ||
            (this.global.user().PE_CodigoPessoa === this.process.SOL_CodigoSolicitante) ||
            (this.userService.isTriagem() && this.process.createdByGroup === 'TRIAGEM')) &&
            allowedStatus.includes(this.process.Status)
    }

    public get isCancellationRequestSectionVisible(): boolean {
        return ((this.process.cancellation_requester_group === UsersGroupEnum.DEPARTMENT_MEMBER || this.userService.isSecretario() &&
            this.global.user().USG_CodigoGrupo === UsersGroupEnum.DEPARTMENT_DIRECTOR) ||
            this.global.user().USR_CodigoUsuario === this.process.PSA_Solicitante) &&
            this.process.Status !== ProcessStatusEnum.CANCELED &&
            !this.process.PSA_AvaliadaPor
    }

    public get canReturnToRequester(): boolean {
        return (
            this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa && 
            !this.process.SOLR_TipoOrgaoFiscalizador &&
            (this.process.Status === 1 || this.process.Status === 2 || this.process.PCOR_Status === 1 || this.process.Status === 8 || this.process.Status === 10) &&
            !this.userService.isCoordTributaria()
        );
    }

    public get isRequestCancellationButtonVisible(): boolean {
        const cancelableStatuses = [
            ProcessStatusEnum.NEW,
            ProcessStatusEnum.IN_PROGRESS,
            ProcessStatusEnum.IN_CORRECTION,
            ProcessStatusEnum.OUTDATED,
            ProcessStatusEnum.AWAITING_REFUND,
            ProcessStatusEnum.AWAITING_PAYMENT,
        ]

        return (cancelableStatuses.includes(this.process.Status) &&
            !this.process.PSA_DataSolicitacao) &&
            this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa &&
            this.userService.isMembroDepartamento()
    }

    public get isCancellationButtonVisible(): boolean {
        const cancelableStatuses = [
            ProcessStatusEnum.NEW,
            ProcessStatusEnum.IN_PROGRESS,
            ProcessStatusEnum.IN_CORRECTION,
            ProcessStatusEnum.OUTDATED,
            ProcessStatusEnum.AWAITING_REFUND,
            ProcessStatusEnum.AWAITING_PAYMENT,
        ]

        return (cancelableStatuses.includes(this.process.Status) &&
            !this.process.PSA_DataSolicitacao) &&
            this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa &&
            (this.userService.isDiretorDepartamento() || this.userService.isAdmin())
    }

    public get canActionsInProcess(): boolean {
        const isResponsible =
            this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa &&
            !this.userService.isCoordTributaria();
    
        const isAdminOrDirector =
            (this.userService.isAdmin() || this.userService.isDiretorDepartamento()) &&
            (this.process.Status !== ProcessStatusEnum.NEW &&
            this.process.Status !== ProcessStatusEnum.PENDING_WITHOUT_RESPONSIBLE);
    
        return isResponsible || isAdminOrDirector;
    }

    public get canToggleResponsible(): boolean {
        return ((this.userService.isDiretorDepartamento() || this.userService.isAdmin()) && this.process.Status !== ProcessStatusEnum.ARCHIVED && !this.userService.isCoordTributaria())
    }

    public get visibleFilingNoteRule() {
        return ((this.process.nota_arquivamento) )
    }

    get canUnarchive(): boolean {
        return (
            (this.userService.isDiretorDepartamento() || 
             this.userService.isAdmOrgao() || 
             this.userService.isAdmin()) 
            && this.process.Status === 3
        );
    }
    
    get canRequestUnarchiving(): boolean {
        return this.userService.isMembroDepartamento() && this.process.Status === 3;
    }
    
    get canUpdateToEvaluation(): boolean {
        return (
            this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa &&
            [5, 8, 9].includes(this.process.Status)
        );
    }
    
    get canAllProgressActions(): boolean {
        const isResponsavel = this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa;
        const isStatusValido = [2, 9, 10, 12].includes(this.process.Status);
    
        return (
            (isStatusValido && isResponsavel && !this.process.SOLR_TipoOrgaoFiscalizador) ||
            (isStatusValido && isResponsavel && this.isPGM && this.process.SOLR_TipoOrgaoFiscalizador)
        );
    }

    handleAddRequestToCancelProcess() {
        const cancelProcessData: IRequestToCancelProcessSchema = {
            reasonCancel: this.entity.cancelProcess.reasonCancel,
            userId: this.global.user().USR_CodigoUsuario,
            history: `${this.global.user().PE_Nome} enviou uma solicitação de anulação do processo.`
        }

        this.processService.addRequestToCancel(this.process.PRC_CodigoProcesso, cancelProcessData).subscribe({
            next: () => {
                this.getProcess(this.process.PRC_CodigoProcesso)

                this.isCancelProcessDialogOpen = false;

                this.messageService.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Uma solicitação de anulação foi enviada para o diretor de seu departamento'
                });
            }
        })
    }

    handleCancelProcess() {
        const confirmProcessCancellationData: ICancellationEvaluationSchema = {
            userId: this.global.user().USR_CodigoUsuario,
            history: `${this.global.user().PE_Nome} confirmou a anulação do processo.`,
            evaluationDescription: this.entity.cancelProcess.reasonCancel
        }

        this.isCancelProcessDialogOpen = false;

        Swal.fire({
            title: 'Confirmar anulação do processo?',
            text: 'Após realizar esta ação, a anulação do processo não poderá ser desfeita.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.confirmCancellationProcess(this.process.PRC_CodigoProcesso, confirmProcessCancellationData).subscribe({
                    next: () => {
                        this.getProcess(this.process.PRC_CodigoProcesso)
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Sucesso',
                            detail: 'O processo foi anulado'
                        });
                    }
                })
            } else {
                this.isCancelProcessDialogOpen = true;
                Swal.close()
            }
        });
    }

    handleReturnToSender(){    
        if (this.InvalidNote) {
            this.messageService.add({
                severity: 'error',
                icon: 'ph ph-x-circle',
                closable: true,
                summary: 'Erro!',
                detail: 'A nota de devolução é obrigatória.',
            });
            return;
        }

        if (!this.process || this.process.Status !== 2 && this.process.Status !== 10 && this.process.Status !== 12 ) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Ação não permitida. Verifique se o processo está em andamento.',
            });
            return;
        }
    
        Swal.fire({
            title: 'Confirmar devolução ao transmitente?',
            text: 'Após esta ação, o processo será devolvido ao responsável anterior.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    NTR_Descricao: this.entity.tramitacao.NTR_Descricao,
                    NTR_Autor: this.global.user().PE_CodigoPessoa,
                    USR_CodigoUsuario: this.global.user().USR_CodigoUsuario,
                    PE_CodigoPessoa: this.global.user().PE_CodigoPessoa,
                };                
    
                this.global.startLoading('Devolvendo...', true);
    
                this.processService
                    .returnToSender(this.process.PRC_CodigoProcesso, payload)
                    .subscribe({
                        next: async () => {
                            this.global.closeModalInfo(this.modalName + '-return-to-sender');
    
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Sucesso!',
                                detail: 'O processo foi devolvido ao transmitente anterior.',
                            });
    
                            await this.getProcess(this.process.PRC_CodigoProcesso);
                            await this.getHistories(this.process.PRC_CodigoProcesso);
    
                            this.global.stopLoading();
                        },
                        error: () => {
                            this.global.stopLoading();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Erro',
                                detail: 'Falha ao devolver o processo.',
                            });
                        },
                    });
            }
        });
    }

    onProcessCancelled(processId: number) {
        this.getProcess(processId);
    }

    public get canArchive(): boolean {
        const canArchiveStatuses = [
            ProcessStatusEnum.CONCLUDED,
            ProcessStatusEnum.CONCLUDED,
            ProcessStatusEnum.CANCELED,
        ]

        return (canArchiveStatuses.includes(this.process.Status)) && (this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa)
            && !this.userService.isCoordTributaria()
    }

    public showModalArchiveNote() {
        if (!this._haveDispatch && this.process.Status !== ProcessStatusEnum.OUTDATED && this.process.Status !== ProcessStatusEnum.CANCELED) {
            this.showMissingDispatchAlert('arquivacao');
        } else {
            this.isArchiveNoteModalOpen = true
        }
    }

    public get isArchivingInfoVisibile(): boolean {
        return (this.process.Status === ProcessStatusEnum.ARCHIVED &&
            !!this.process.PRC_NotaArquivamento
        )
    }

    public get requestUnarchivingButton() {
        return  ((this.userService.isDiretorDepartamento()) &&
        this.process.PRT_DepartamentoAtual === this.global.user().PE_CodigoDepartamento)
    }

    public get acceptUnarchivingRequestRule() {
        return (this.userService.isSecretario() && this.global.user().OR_CodigoOrgao == this.process.SOL_CodigoOrgao) 
               || this.userService.isAdmin()
    }

    getResponsibleRequests(processId: number) {
        this.processService.getResponsibleRequests(processId).subscribe({
            next: (response: any) => {
                this.responsibleRequest = response.data;
            }
        })
    }

    public get organizationIsSemurb() {
        return this.process.OR_NumeroOrgao == OrganizationEnum.SEMURB
    }

    public getCorrections(processId: number) {
        this.processService.getAllCorrections(processId).subscribe({
            next: (response: any) => {
                this.corrections = response.data;
            }
        })
    }

    acceptRejectBeingResponsible(type) {
        this.responsibleRequest.type = type
        let message: any;

        if (type == 'accept') {
            message = {
                severity: 'success',
                icon: 'ph ph-check-circle',
                closable: true,
                summary: 'Sucesso!',
                detail: 'Você aceitou ser responsável desse processo.'
            };
        }
        else {
            message = {
                severity: 'error',
                closable: true,
                detail: 'Você recusou ser responsável desse processo.'
            };
        }

        this.processService.sendAcceptBeingResponsible(this.responsibleRequest.RESAC_CodigoProcesso, this.responsibleRequest).subscribe({
            next: (response: any) => {
                this.getProcess(this.responsibleRequest.RESAC_CodigoProcesso);
                this.messageService.add(message);
                this.global.closeModalInfo('reject-responsible');
                window.location.reload();
            }
        })
    }

    getBucketNameFromTypeDocument(type: string, orgSigla: string) {
        switch (type) {
            case "procuracao":
                return null
            case "REQUERIMENTO":
                if (this.process.SOL_CodigoDocumento) return "SIGN";
                return orgSigla
            default:
                return orgSigla
        }    
    }

    public async handleCancelComplementaryFiles(fileId: number) {

        const result = await Swal.fire({
            title: 'Tem certeza que deseja anular este arquivo?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        });

        if (result.isConfirmed) {
            this.processService.cancelComplementaryFiles(this.process.PRC_CodigoProcesso, fileId).subscribe({
                next: (response: any) => {
                    Swal.fire('Arquivo Anulado!', 'Seu arquivo foi anulado com sucesso.', 'success');

                    this.getProcess(this.process.PRC_CodigoProcesso);
                    window.location.reload();
                },
                error: (error: any) => {
                    console.error('Erro ao anular o arquivo:', error);
                    Swal.fire('Erro ao anular o arquivo', 'Ocorreu um erro ao anular o arquivo.', 'error');
                }
            });
        } else {
            Swal.fire('Operação Cancelada', 'O arquivo não foi anulado.', 'info');
        }
    } catch(error) {
        console.error('Erro ao mostrar confirmação:', error);
    }

    async generatePDF(process) {
        this.isLoading = true;

        const listBlob = await this.processService.generateProcessPDF(process)

        const normalizedInternalProcessNumber = this.process.PRC_NumeroProcesso.replace(/\./g, ''); 
        
        const idDownload = this.globalStateService.addDownload({
            name: "Processo " + this.process.PRC_NumeroProcesso,
            type: 0,
            percent: 0
        })

        this.processService.mergedDocumentInPdf( 
            listBlob, 
            this.process.PRC_CodigoProcesso,
            this.process.PRC_NumeroProcesso.replace(/[.\-]/g, ''),
            this.process.OR_Sigla
        ).subscribe((event: HttpEvent<any>) => {
            this.globalStateService.getEventsRequest(event, idDownload);
            if (event.type == HttpEventType.Response) {
                if (event.body instanceof Blob) {
                    this.global.saveFile(event.body, `Processo - ${this.process.PRC_NumeroProcesso}.pdf`);
                    this.isLoading = false;
                }
            }
        });

    }

    get isCitizen() {
        return this.userService.isCidadao();
    }

    consultarDam(damId: string) {
        if (damId) {
          this.searchPerformed = true;
          this.global.startLoading('Consultando DAM...', true);
          this.fiscoService.getDataDam(damId).subscribe({
            next: (response: any) => {
              if (response.success) {

                if (this.process.dam) {
                    const filteredProcessDams = this.process.dam.filter(d => d.PDAM_NumeroDam === response.data.id.toString());
    
                    if (filteredProcessDams.length > 0) {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'O DAM que você está tentando adicionar já está no processo.'
                        });
                    } else {
                        this.damData = [response.data];
                        this.showDamTable = true;
                        this.isSearchDamModalOpen = true;
                    }
                } else {
                    this.damData = [response.data];
                    this.showDamTable = true;
                    this.isSearchDamModalOpen = true;
                }
                
              } else {
                this.damData = [];
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: 'Não foi possível encontrar o DAM que você buscou. Por favor, digite um número de DAM válido.'
                });
                this.showDamTable = false;
              }
            },
            error: (error) => {
              this.damData = [];
              this.showDamTable = false;
              this.global.stopLoading();
            },
            complete: () => {
                this.global.stopLoading();
            }
          });
        }
    }

    consultarNegociacao(negociacaoId: string) {
        if (negociacaoId) {
          this.searchPerformed = true;
          this.global.startLoading('Consultando Negociação...', true);
          this.fiscoService.getDataNegociacao(negociacaoId).subscribe({
            next: (response: any) => {
              if (response.success) {
                if (this.process.negociacao) {
                    const filteredProcessNegociacoes = this.process.negociacao.filter(d => d.PNEG_NumeroNegociacao === response.data.id.toString());
    
                    if (filteredProcessNegociacoes.length > 0) {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'A negociação que você está tentando adicionar já está no processo.'
                        });
                    } else {
                        this.negociacaoData = [response.data];
                        this.showNegociacaoTable = true;
                        this.isSearchNegociacaoModalOpen = true;
                    }
                } else {
                    this.negociacaoData = [response.data];
                    this.showNegociacaoTable = true;
                    this.isSearchNegociacaoModalOpen = true;
                }
                
              } else {
                this.negociacaoData = [];
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: response.message || 'Não foi possível encontrar a negociação que você buscou. Por favor, digite um número de negociação válido.'
                });
                this.showNegociacaoTable = false;
              }
            },
            error: (error) => {
              this.negociacaoData = [];
              this.showNegociacaoTable = false;
              this.global.stopLoading();
            },
            complete: () => {
                this.global.stopLoading();
            }
          });
        }
    }

    reopenProcess() {
        Swal.fire({
            title: 'Confirmar reabertura do processo?',
            text: 'Após realizar esta ação, a reabertura do processo não poderá ser interrompida.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                this.global.startLoading();
                this.processService.reopenProcess(this.process.PRC_CodigoProcesso).subscribe({
                    next: () => {
                        this.getProcess(this.process.PRC_CodigoProcesso);
                        this.getHistories(this.process.PRC_CodigoProcesso);
                        this.global.stopLoading();
                    }
                })
            } else {
                Swal.close();
                this.global.stopLoading();
            }
        });
    }

    associarDamAoProcesso(damId: string) {
        const damSituacao = this.damData[0]?.situacao;
        this.isSearchDamModalOpen = false;
    
        Swal.fire({
            title: 'Tem certeza que deseja associar este DAM ao processo?',
            text: 'Verifique se o DAM selecionado é o correto antes de confirmar.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.global.startLoading('Associando DAM...', true);
                this.processService.associarDam(this.process.PRC_CodigoProcesso, damId, damSituacao).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O DAM foi associado ao processo com sucesso.'
                        });
                        this.formattedDams.push(this.damData[0]);
                        this.getProcess(this.process.PRC_CodigoProcesso); 
                    },
                    error: () => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao associar o DAM ao processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                this.isSearchDamModalOpen = true;
                Swal.close();
            }
        });
    }
    

    removeDamFromProcess(damId: number) {
        Swal.fire({
            title: 'Tem certeza que deseja remover este DAM do processo?',
            text: 'Ao confirmar, o DAM será removido deste processo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.removeDam(this.process.PRC_CodigoProcesso, damId).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O DAM foi removido do processo.'
                        });
                        this.formattedDams = this.formattedDams.filter(dam => dam.id !== damId);
                        this.getProcess(this.process.PRC_CodigoProcesso);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao remover o DAM do processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                Swal.close();
            }
        });
    }

    get shouldShowReopenButton() {
        const reopenableStatuses = [
            ProcessStatusEnum.ARCHIVED,
            ProcessStatusEnum.CONCLUDED,
            ProcessStatusEnum.CANCELED,
            ProcessStatusEnum.OUTDATED,
            ProcessStatusEnum.EXPIRED_WITHOUT_ANALYSIS,
        ];
        return this.userService.isAdmin() && reopenableStatuses.includes(this.process.Status) && !this.userService.isCoordTributaria();
    }

    skeletonHidden() {
        if (this.skeletronLoaded.complementaryFiles.show) {
            this.skeletronLoaded.complementaryFiles.show = false;
        }
        if (this.skeletronLoaded.dispatch.show) {
            this.skeletronLoaded.dispatch.show = false;
        }
        if (this.skeletronLoaded.certificate.show) {
            this.skeletronLoaded.certificate.show = false;
        }
    }
    
    get returnToSenderRole() {
        const returnToSenderRoleStatuses = [
            ProcessStatusEnum.IN_PROGRESS,
            ProcessStatusEnum.AWAITING_REFUND,
            ProcessStatusEnum.AWAITING_PAYMENT,
        ]

        return ((returnToSenderRoleStatuses.includes(this.process.Status)) && 
            this.process.lastResposible && 
            this.global.user().PE_CodigoPessoa === this.process.PRC_CodigoResponsavel &&
            this.process.lastResposible.HRA_CodigoResponsavel != this.global.user().PE_CodigoPessoa &&
            !this.userService.isCoordTributaria()
        )
    }

    get isCorrection() {
        return this.process?.Status === ProcessStatusEnum.IN_CORRECTION
    }

    onDeleteComplementaryFilesUploaded(event) {
        const index =  (event.index - (this.process.processo_anexo.length - 1)) - 1;
        if (this.isCorrection) {
            this.complementaryFilesFromCorrection.splice(index, 1)
        }
    }

    get hasRequesterAndCorrection(): boolean {
        return this.process?.SOL_CodigoSolicitante == this.global.user().PE_CodigoPessoa && this.process?.Status == ProcessStatusEnum.IN_CORRECTION
    }

    get totalComplementaryFilesCount(): number {
        return this.process?.processo_anexo?.length || 0;
    }
      
    get hasNewComplementaryFiles(): boolean {
        if (!this.process?.processo_anexo) return false;
      
        const now = new Date().getTime();
        const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000;
      
        return this.process.processo_anexo.some((file: any) => {
          const fileDate = new Date(file.created_at).getTime();
          return fileDate >= twentyFourHoursAgo;
        });
    }

    get isPGM() {
        return OrganizationEnum.PGM == this.global.user().OR_NumeroOrgao;
    }

    associarNegociacaoAoProcesso(negociacaoId: string) {
        this.isSearchNegociacaoModalOpen = false
        Swal.fire({
            title: 'Tem certeza que deseja associar esta negociação ao processo?',
            text: 'Verifique se a negociação selecionada é a correta antes de confirmar.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.global.startLoading('Associando Negociação...', true);
                this.processService.associarNegociacao(this.process.PRC_CodigoProcesso, negociacaoId).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'A Negociação foi associado ao processo com sucesso.'
                        });
                        this.formattedNegociacoes.push(this.negociacaoData[0])
                        this.getProcess(this.process.PRC_CodigoProcesso);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao associar a negociação ao processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                this.isSearchNegociacaoModalOpen = true;
                Swal.close();
            }
        });
    }

    removeNegociacaoFromProcess(negociacaoId: number) {
        Swal.fire({
            title: 'Tem certeza que deseja remover esta negociação do processo?',
            text: 'Ao confirmar, a negociação será removida deste processo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.removeNegociacao(this.process.PRC_CodigoProcesso, negociacaoId).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'A negociação foi removida do processo.'
                        });
                        this.formattedNegociacoes = this.formattedNegociacoes.filter(negociacao => negociacao.id !== negociacaoId);
                        this.getProcess(this.process.PRC_CodigoProcesso);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao remover a negociação do processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                Swal.close();
            }
        });
    }

    public get canChangeNegociacao() {
        const negociacoes = this.process?.negociacao || [];
        return (
          ((this.global.user().PE_CodigoPessoa === this.process?.PRC_CodigoResponsavel) 
          || this.userService.isAdmin()) 
          && negociacoes.length === 0
        );
    }

    getDataPdfNegociacao(id: number, codigo: number, anexo: string) {
        if (anexo) {
            this.uploadService.download(anexo, 'SIGN')
            .pipe(
                switchMap((response: any) => this.uploadService.downloadAndReturnArrayBuffer(response.url))
            )
            .subscribe({
                next: (response: any) => {
                    this.dataPdfNegociacao = {
                        pdfBase64: this.global.arrayBufferToBase64(response),
                        pdfBuffer: response,
                        pdfFileName: "termo_negociacao_" + id
                    }

                    this.isSignatureModalOpen = true;
                    this.codigoNegociacaoPdf = codigo;
                },
                error: (error: any) => {
                    console.error('Erro no download:', error);
                },
            })
        }
        else {
            this.fiscoService.getPdfNegociacaoFisco(id).subscribe({
                next: (response: any) => {
                  this.dataPdfNegociacao = response.data;
                  this.isSignatureModalOpen = true;
                  this.codigoNegociacaoPdf = codigo;
                }
            });
        }
    }

    getDataPdfAlvara(numeroAlvara: number, exercicio: number, codigo: number, anexo: string) {
        if (anexo) {
            this.uploadService.download(anexo, 'SIGN')
            .pipe(
                switchMap((response: any) => this.uploadService.downloadAndReturnArrayBuffer(response.url))
            )
            .subscribe({
                next: (response: any) => {
                    this.dataPdfAlvara = {
                        pdfBase64: this.global.arrayBufferToBase64(response),
                        pdfBuffer: response,
                        pdfFileName: "alvara_sanitario_" + numeroAlvara
                    }

                    this.isSignatureAlvaraModalOpen = true;
                    this.codigoAlvaraPdf = codigo;
                },
                error: (error: any) => {
                    console.error('Erro no download:', error);
                },
            })
        }
        else {
            this.fiscoService.getPdfAlvaraSanitario(numeroAlvara, exercicio).subscribe({
                next: (response: any) => {
                  this.dataPdfAlvara = response.data;
                  this.isSignatureAlvaraModalOpen = true;
                  this.codigoAlvaraPdf = codigo;
                }
            });
        }
    }

    getEventSignature(event: SignedFileDataResponse) {
        this.global.startLoading();
        const person = this.global.user().PE_CodigoPessoa;
        this.processService.atualizarUrlTermo(this.process.PRC_CodigoProcesso, this.codigoNegociacaoPdf, event.fileCloudFlare, person).subscribe({
            next: () => {
              this.isSignatureModalOpen = false;
              this.getProcess(this.process.PRC_CodigoProcesso);
              this.global.stopLoading();
            }
        });
    }

    getEventSignatureAlvara(event: SignedFileDataResponse) {
        this.global.startLoading();
        this.processService.atualizarUrlAlvaraSanitario(this.process.PRC_CodigoProcesso, this.codigoAlvaraPdf, event.fileCloudFlare).subscribe({
            next: () => {
              this.isSignatureAlvaraModalOpen = false;
              this.getProcess(this.process.PRC_CodigoProcesso);
              this.global.stopLoading();
            }
        });
    }

    downloadPdf(anexo: string) {
        this.uploadService.download(anexo, 'SIGN').subscribe({
            next: (response: any) => {
                if (response.url) {
                    window.open(response.url, '_blank');
                }
            },
            error: (error: any) => {
                console.error('Erro no download:', error);
            },
        })
    }

    updatePermissionFisco(): void {
        this.canSearchFisco = (this.global.user().PE_CodigoPessoa === this.process?.PRC_CodigoResponsavel) || this.userService.isAdmin();
    }

    consultarAlvara(tipoAlvara: string, numero: number, exercicio: number) {
        if (tipoAlvara && numero && exercicio) {
            this.searchPerformed = true;
            this.global.startLoading('Consultando Alvará...', true);
    
            this.fiscoService.getDataAlvara(tipoAlvara, numero, exercicio).subscribe({
                next: (response: any) => {
                    if (response.success) {
    
                        if (this.process.alvara) {
                            const filteredProcessAlvaras = this.process.alvara.filter(
                                a => a.tipo === tipoAlvara && a.numero === numero && a.exercicio === exercicio
                            );
    
                            if (filteredProcessAlvaras.length > 0) {
                                this.messageService.add({
                                    severity: 'error',
                                    icon: 'ph ph-x-circle',
                                    closable: true,
                                    summary: 'Erro!',
                                    detail: 'O Alvará que você está tentando adicionar já está no processo.'
                                });
                            } else {
                                this.alvaraData = [response.data];
                                this.showAlvaraTable = true;
                                this.isSearchAlvaraModalOpen = true;
                            }
                        } else {
                            this.alvaraData = [response.data];
                            this.showAlvaraTable = true;
                            this.isSearchAlvaraModalOpen = true;
                        }
    
                    } else {
                        this.alvaraData = [];
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Não foi possível encontrar o Alvará informado. Verifique os dados digitados.'
                        });
                        this.showAlvaraTable = false;
                    }
                },
                error: (error) => {
                    this.alvaraData = [];
                    this.showAlvaraTable = false;
                    this.global.stopLoading();
                },
                complete: () => {
                    this.global.stopLoading();
                }
            });
        }
    }

    associarAlvaraAoProcesso(tipo: string, numero: number, exercicio: number) {
        this.isSearchAlvaraModalOpen = false;
        Swal.fire({
        title: 'Tem certeza que deseja associar este Alvará ao processo?',
        text: 'Verifique se o Alvará selecionado é o correto antes de confirmar.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#417bff',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
        }).then((result) => {
        if (result.isConfirmed) {
            this.global.startLoading('Associando Alvará...', true);
            this.processService.associarAlvara(this.process.PRC_CodigoProcesso, tipo, numero, exercicio).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    icon: 'ph ph-check-circle',
                    closable: true,
                    summary: 'Sucesso!',
                    detail: 'O Alvará foi associado ao processo com sucesso.'
                });
                this.formattedAlvaras.push(this.alvaraData[0]);
                this.getProcess(this.process.PRC_CodigoProcesso);
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    icon: 'ph ph-x-circle',
                    closable: true,
                    summary: 'Erro!',
                    detail: 'Ocorreu um erro ao associar o Alvará ao processo.'
                });
                this.global.stopLoading();
            },
            complete: () => {
                this.global.stopLoading();
            }
            });
        } else {
            this.isSearchAlvaraModalOpen = true;
            Swal.close();
        }
        });
    }

    removeAlvaraFromProcess(tipo: string, numero: number, exercicio: number) {
        Swal.fire({
            title: 'Tem certeza que deseja remover este alvará do processo?',
            text: 'Ao confirmar, o alvará será removido deste processo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.removeAlvara(this.process.PRC_CodigoProcesso, tipo, numero, exercicio).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O alvará foi removido do processo.'
                        });
                        this.formattedAlvaras = this.formattedAlvaras.filter(alvara =>
                            !(alvara.tipo === tipo && alvara.numero === numero && alvara.exercicio === exercicio)
                        );
                        this.getProcess(this.process.PRC_CodigoProcesso);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao remover o alvará do processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                Swal.close();
            }
        });
    }

    permitirSomenteNumeros(event: KeyboardEvent) {
        const charCode = event.charCode;
        if (charCode < 48 || charCode > 57) {
          event.preventDefault();
        }
    }

    get canSignAlvara(): boolean {
        return this.process.PRC_CodigoResponsavel === this.global.user().PE_CodigoPessoa &&
               this.global.user().DEP_Descricao === 'VIGILÂNCIA SANITÁRIA' &&
               this.userService.isDiretorDepartamento();
    }

    formatCertificadoData() {
        const certificadoPromises = this.process.certificado.map((certificado) => {
            return new Promise((resolve) => {
                this.fiscoService.getDataCertificado(certificado.PCER_Numero, certificado.PCER_Exercicio).subscribe({
                    next: (response: any) => {
                        if (response.success) {
                            const certificadoData = {
                                codigo: certificado?.PCER_CodigoProcessoCertificado,
                                contribuinte: response.data.contribuinte,
                                numero: response.data.numero,
                                link: response.data.link,
                                vencimento: response.data.vencimento,
                                dam_pago: response.data.dam_pago,
                                exercicio: certificado?.PCER_Exercicio,
                                anexoCloudflare: certificado?.PCER_Anexo,
                                assinado: certificado?.PCER_Assinado
                            };
                            resolve(certificadoData);
                        } else {
                            resolve(null);
                        }
                    },
                    error: () => {
                        resolve(null);
                    }
                });
            });
        });

        Promise.all(certificadoPromises).then((certificados) => {
            this.formattedCertificados = certificados;
            this.showCertificadoTable = true;
        });
    }

    consultarCertificado(numero: number, exercicio: number) {
        if (numero && exercicio) {
            this.searchPerformed = true;
            this.global.startLoading('Consultando Certificado...', true);
    
            this.fiscoService.getDataCertificado(numero, exercicio).subscribe({
                next: (response: any) => {
                    if (response.success) {
                        console.log(this.process.certificado);
                        if (this.process.certificado) {
                            const filteredProcessCertificados = this.process.certificado.filter(
                                a => a.PCER_Numero === +numero && a.PCER_Exercicio === +exercicio
                            );
    
                            if (filteredProcessCertificados.length > 0) {
                                this.messageService.add({
                                    severity: 'error',
                                    icon: 'ph ph-x-circle',
                                    closable: true,
                                    summary: 'Erro!',
                                    detail: 'O Certificado que você está tentando adicionar já está no processo.'
                                });
                            } else {
                                this.certificadoData = [response.data];
                                this.showCertificadoTable = true;
                                this.isSearchCertificadoModalOpen = true;
                            }
                        } else {
                            this.certificadoData = [response.data];
                            this.showCertificadoTable = true;
                            this.isSearchCertificadoModalOpen = true;
                        }
                    } else {
                        this.certificadoData = [];
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Não foi possível encontrar o Certificado informado. Verifique os dados digitados.'
                        });
                        this.showCertificadoTable = false;
                    }
                },
                error: (error) => {
                    this.certificadoData = [];
                    this.showCertificadoTable = false;
                    this.global.stopLoading();
                },
                complete: () => {
                    this.global.stopLoading();
                }
            });
        }
    }

    associarCertificadoAoProcesso(numero: number, exercicio: number) {
        const hasPaidDam = this.formattedDams && this.formattedDams.some(dam => dam?.situacao === 'PAGO');

        if (!hasPaidDam) {
            this.isSearchCertificadoModalOpen = false;
            this.messageService.add({
                severity: 'warn',
                icon: 'ph ph-warning',
                closable: true,
                summary: 'Atenção!',
                detail: 'Não é possível anexar o certificado. É necessário ter um DAM associado e pago no processo.'
            });
            return;
        }

        this.isSearchCertificadoModalOpen = false;
        Swal.fire({
            title: 'Tem certeza que deseja associar este Certificado ao processo?',
            text: 'Verifique se o certificado selecionado é o correto antes de confirmar.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.global.startLoading('Associando Certificado...', true);
                this.processService.associarCertificado(this.process.PRC_CodigoProcesso, numero, exercicio).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        icon: 'ph ph-check-circle',
                        closable: true,
                        summary: 'Sucesso!',
                        detail: 'O Certificado foi associado ao processo com sucesso.'
                    });
                    this.formattedCertificados.push(this.certificadoData[0]);
                    this.getProcess(this.process.PRC_CodigoProcesso);
                },
                error: () => {
                    this.messageService.add({
                        severity: 'error',
                        icon: 'ph ph-x-circle',
                        closable: true,
                        summary: 'Erro!',
                        detail: 'Ocorreu um erro ao associar o certificado ao processo.'
                    });
                    this.global.stopLoading();
                },
                complete: () => {
                    this.global.stopLoading();
                }
                });
            } else {
                this.isSearchCertificadoModalOpen = true;
                Swal.close();
            }
        });
    }

    removeCertificadoFromProcess( numero: number, exercicio: number) {
        Swal.fire({
            title: 'Tem certeza que deseja remover este certificado do processo?',
            text: 'Ao confirmar, o certificado será removido deste processo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#417bff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.processService.removeCertificado(this.process.PRC_CodigoProcesso, numero, exercicio).subscribe({
                    next: () => {
                        this.messageService.add({
                            severity: 'success',
                            icon: 'ph ph-check-circle',
                            closable: true,
                            summary: 'Sucesso!',
                            detail: 'O certificado foi removido do processo.'
                        });
                        this.formattedCertificados = this.formattedCertificados.filter(certificado =>
                            !(certificado.numero === numero && certificado.exercicio === exercicio)
                        );
                        this.getProcess(this.process.PRC_CodigoProcesso);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            icon: 'ph ph-x-circle',
                            closable: true,
                            summary: 'Erro!',
                            detail: 'Ocorreu um erro ao remover o certificado do processo.'
                        });
                        this.global.stopLoading();
                    },
                    complete: () => {
                        this.global.stopLoading();
                    }
                });
            } else {
                Swal.close();
            }
        });
    }

    getDataPdfCertificado(numeroCertificado: number, exercicio: number, codigo: number, anexo: string) {
        if (anexo) {
            this.uploadService.download(anexo, 'SIGN')
            .pipe(
                switchMap((response: any) => this.uploadService.downloadAndReturnArrayBuffer(response.url))
            )
            .subscribe({
                next: (response: any) => {
                    this.dataPdfCertificado = {
                        pdfBase64: this.global.arrayBufferToBase64(response),
                        pdfBuffer: response,
                        pdfFileName: "certificado_vistoria_" + numeroCertificado
                    }

                    this.isSignatureCertificadoModalOpen = true;
                    this.codigoCertificadoPdf = codigo;
                },
                error: (error: any) => {
                    console.error('Erro no download:', error);
                },
            })
        }
        else {
            this.fiscoService.getPdfCertificado(numeroCertificado, exercicio).subscribe({
                next: (response: any) => {
                  this.dataPdfCertificado = response.data;
                  this.isSignatureCertificadoModalOpen = true;
                  this.codigoCertificadoPdf = codigo;
                }
            });
        }
    }

    getEventSignatureCertificado(event: SignedFileDataResponse) {
        this.global.startLoading();
        this.processService.atualizarUrlCertificado(this.process.PRC_CodigoProcesso, this.codigoCertificadoPdf, event.fileCloudFlare).subscribe({
            next: () => {
              this.isSignatureCertificadoModalOpen = false;
              this.getProcess(this.process.PRC_CodigoProcesso);
              this.global.stopLoading();
            }
        });
    }

    get canSignCertificado(): boolean {
        return this.global.user().DEP_Descricao === 'VIGILÂNCIA SANITÁRIA' && this.userService.isDiretorDepartamento();
    }


}